// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jIZNE","toggle":"styles_toggle__HpS3v","preview":"styles_preview__2VyUz"};